<template>
  <input-field
    type="text"
    :label="$t('authenticationFirstNameLabel')"
    v-bind="$attrs"
    v-on:input="$emit('input', $event)"
  >
    <template v-slot:accessory>
      <slot name="accessory" />
    </template>
  </input-field>
</template>

<script>
  import InputField from './InputField.vue';

  export default {
    name: 'InputFirstNameField',
    inheritAttrs: false,
    components: {
      InputField,
    }
  }
</script>
